<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<section epub:type="epigraph" role="doc-epigraph">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="EP"><span aria-label="vii" id="pg_vii" role="doc-pagebreak">To refine, to clarify, to intensify that eternal moment in which we alone live there is but a single force—the imagination.</span></p>
<p class="EPC">—William Carlos Williams, <i>Spring and All</i></p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?333ce7a8